@if (breadcrumbs.length > 0) {
<div class="pcs-breadcrumb d-flex py-3 justify-content-center align-items-center w-100 mt-0">
  @for (link of breadcrumbs ; track link; let last = $last) {
<span class="d-flex align-items-center">
    <a [routerLink]="link.url" [queryParams]="link.queryParams" [fragment]="link.fragment"> {{ link.text }} </a>
    @if (!last) {
<app-vficon
      class="icon d-flex px-2"
     
      iconPack="source-system-icons"
      iconName="chevron-right"
    ></app-vficon>
}
  </span>
}
</div>
}
